import posthog from 'posthog-js'

let initialized = false

function init() {
  if (initialized) return
  const key = import.meta.env.VITE_POSTHOG_KEY
  if (!key) return

  posthog.init(key, {
    // Region-configurable: InnovateX's PostHog org is EU-hosted, so default to the
    // EU ingest host. Override with VITE_POSTHOG_HOST if the app project lives elsewhere.
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
    person_profiles: 'identified_only',
    autocapture: false,
    capture_pageview: true,
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: { password: true, email: true },
    },
    sanitize_properties(properties) {
      Object.keys(properties).forEach((k) => {
        if (/token|secret|password|auth/i.test(k)) delete properties[k]
      })
      return properties
    },
  })
  initialized = true
}

export function identifyUser(email: string, displayName: string): void {
  init()
  posthog.identify(email, { name: displayName, email })
}

export function resetAnalytics(): void {
  if (initialized) posthog.reset()
}

type EventName =
  | 'opportunity_created'
  | 'opportunity_stage_changed'
  | 'contact_created'
  | 'note_created'
  | 'ai_feature_used'
  | 'intake_item_processed'
  | 'auth_token_expired'
  | 'api_error'

export function trackEvent(event: EventName, properties?: Record<string, unknown>): void {
  if (!initialized) return
  // Strip any accidental PII before sending
  const safe = properties
    ? Object.fromEntries(
        Object.entries(properties).filter(([k]) => !/token|secret|password|auth/i.test(k)),
      )
    : undefined
  posthog.capture(event, safe)
}
